import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import {
  SerializerFactory1qv9hivitncuv as SerializerFactory,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { BooleanSerializer_getInstance22aja3hu17sxf as BooleanSerializer_getInstance } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Primitives.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { $serializer1poubtr9zukuj as $serializer } from '../events/eventModels.mjs';
import {
  $serializer_getInstance16n3ee7c06gio as $serializer_getInstance,
  Companion_getInstance2ckxqlwfswrwh as Companion_getInstance,
} from '../notificationModels.mjs';
import { get_nullable197rfua9r7fsz as get_nullable } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { HasId24qpfucecockd as HasId } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/HasId.mjs';
import { SerializableWithd2dap36updxd as SerializableWith } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializersJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.notifications.subscriptions.NotificationSendMethods.DbOrDefault', null, 2);
        tmp0_serialDesc.addElement_5pzumi_k$('subscription', false);
        tmp0_serialDesc.addElement_5pzumi_k$('isDefault', false);
        this.$cachedDescriptor_1 = tmp0_serialDesc;
      }
      serializer_rzxuna_k$(typeSerial0) {
        return $serializer_0().new_com_lightningkite_lightningserver_notifications_subscriptions_NotificationSendMethods_DbOrDefault_$serializer_4j33na_k$(typeSerial0);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_rzxuna_k$(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_0() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var $serializerClass;
function $serializer_0() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        return new.target.new_com_lightningkite_lightningserver_notifications_subscriptions_NotificationSendMethods_DbOrDefault_$serializer_ngdhmi_k$();
      }
      static new_com_lightningkite_lightningserver_notifications_subscriptions_NotificationSendMethods_DbOrDefault_$serializer_ngdhmi_k$() {
        var $this = createThis(this);
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.notifications.subscriptions.NotificationSendMethods.DbOrDefault', $this, 2);
        tmp0_serialDesc.addElement_5pzumi_k$('subscription', false);
        tmp0_serialDesc.addElement_5pzumi_k$('isDefault', false);
        $this.descriptor_1 = tmp0_serialDesc;
        return $this;
      }
      serialize_smzva6_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, $serializer_1().new_com_lightningkite_lightningserver_notifications_subscriptions_NotificationSendMethods_$serializer_25jatz_k$(this.typeSerial0__1), value.subscription_1);
        tmp1_output.encodeBooleanElement_ydht7q_k$(tmp0_desc, 1, value.isDefault_1);
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_smzva6_k$(encoder, value instanceof DbOrDefault() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = false;
        var tmp6_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp6_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, $serializer_1().new_com_lightningkite_lightningserver_notifications_subscriptions_NotificationSendMethods_$serializer_25jatz_k$(this.typeSerial0__1), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, $serializer_1().new_com_lightningkite_lightningserver_notifications_subscriptions_NotificationSendMethods_$serializer_25jatz_k$(this.typeSerial0__1), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp6_input.endStructure_1xqz0n_k$(tmp0_desc);
        return DbOrDefault().new_com_lightningkite_lightningserver_notifications_subscriptions_NotificationSendMethods_DbOrDefault_yahqks_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [$serializer_1().new_com_lightningkite_lightningserver_notifications_subscriptions_NotificationSendMethods_$serializer_25jatz_k$(this.typeSerial0__1), BooleanSerializer_getInstance()];
      }
      typeParametersSerializers_fr94fx_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [this.typeSerial0__1];
      }
      static new_com_lightningkite_lightningserver_notifications_subscriptions_NotificationSendMethods_DbOrDefault_$serializer_4j33na_k$(typeSerial0) {
        var $this = this.new_com_lightningkite_lightningserver_notifications_subscriptions_NotificationSendMethods_DbOrDefault_$serializer_ngdhmi_k$();
        $this.typeSerial0__1 = typeSerial0;
        return $this;
      }
    }
    initMetadataForClass($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var DbOrDefaultClass;
function DbOrDefault() {
  if (DbOrDefaultClass === VOID) {
    class $ {
      constructor(subscription, isDefault) {
        Companion_getInstance_0();
        this.subscription_1 = subscription;
        this.isDefault_1 = isDefault;
      }
      toString() {
        return 'DbOrDefault(subscription=' + this.subscription_1.toString() + ', isDefault=' + this.isDefault_1 + ')';
      }
      hashCode() {
        var result = this.subscription_1.hashCode();
        result = imul(result, 31) + getBooleanHashCode(this.isDefault_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof DbOrDefault()))
          return false;
        if (!this.subscription_1.equals(other.subscription_1))
          return false;
        if (!(this.isDefault_1 === other.isDefault_1))
          return false;
        return true;
      }
      static new_com_lightningkite_lightningserver_notifications_subscriptions_NotificationSendMethods_DbOrDefault_yahqks_k$(seen0, subscription, isDefault, serializationConstructorMarker) {
        Companion_getInstance_0();
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, Companion_getInstance_0().$cachedDescriptor_1);
        }
        var $this = createThis(this);
        $this.subscription_1 = subscription;
        $this.isDefault_1 = isDefault;
        return $this;
      }
    }
    initMetadataForClass($, 'DbOrDefault', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_0});
    DbOrDefaultClass = $;
  }
  return DbOrDefaultClass;
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.notifications.subscriptions.NotificationSendMethods', null, 5);
        tmp0_serialDesc.addElement_5pzumi_k$('_id', false);
        tmp0_serialDesc.addElement_5pzumi_k$('email', false);
        tmp0_serialDesc.addElement_5pzumi_k$('push', false);
        tmp0_serialDesc.addElement_5pzumi_k$('sms', false);
        tmp0_serialDesc.addElement_5pzumi_k$('inApp', true);
        this.$cachedDescriptor_1 = tmp0_serialDesc;
      }
      serializer_rzxuna_k$(typeSerial0) {
        return $serializer_1().new_com_lightningkite_lightningserver_notifications_subscriptions_NotificationSendMethods_$serializer_25jatz_k$(typeSerial0);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_rzxuna_k$(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_0;
function Companion_getInstance_1() {
  if (Companion_instance_0 === VOID)
    new (Companion_0())();
  return Companion_instance_0;
}
var $serializerClass_0;
function $serializer_1() {
  if ($serializerClass_0 === VOID) {
    class $ {
      constructor() {
        return new.target.new_com_lightningkite_lightningserver_notifications_subscriptions_NotificationSendMethods_$serializer_u3zkjf_k$();
      }
      static new_com_lightningkite_lightningserver_notifications_subscriptions_NotificationSendMethods_$serializer_u3zkjf_k$() {
        var $this = createThis(this);
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.notifications.subscriptions.NotificationSendMethods', $this, 5);
        tmp0_serialDesc.addElement_5pzumi_k$('_id', false);
        tmp0_serialDesc.addElement_5pzumi_k$('email', false);
        tmp0_serialDesc.addElement_5pzumi_k$('push', false);
        tmp0_serialDesc.addElement_5pzumi_k$('sms', false);
        tmp0_serialDesc.addElement_5pzumi_k$('inApp', true);
        $this.descriptor_1 = tmp0_serialDesc;
        return $this;
      }
      serialize_ajcn38_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, $serializer().new_com_lightningkite_lightningserver_notifications_events_UserEventType_$serializer_b1r9ke_k$(this.typeSerial0__1), value._id_1);
        tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 1, $serializer_getInstance(), value.email_1);
        tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 2, $serializer_getInstance(), value.push_1);
        tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 3, $serializer_getInstance(), value.sms_1);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 4) ? true : !equals(value.inApp_1, Companion_getInstance().immediately_trp1j6_k$())) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 4, $serializer_getInstance(), value.inApp_1);
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_ajcn38_k$(encoder, value instanceof NotificationSendMethods() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp9_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp9_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, $serializer().new_com_lightningkite_lightningserver_notifications_events_UserEventType_$serializer_b1r9ke_k$(this.typeSerial0__1), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp9_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 1, $serializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp9_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 2, $serializer_getInstance(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp9_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 3, $serializer_getInstance(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp9_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 4, $serializer_getInstance(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp9_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp9_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, $serializer().new_com_lightningkite_lightningserver_notifications_events_UserEventType_$serializer_b1r9ke_k$(this.typeSerial0__1), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp9_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 1, $serializer_getInstance(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp9_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 2, $serializer_getInstance(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp9_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 3, $serializer_getInstance(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp9_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 4, $serializer_getInstance(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp9_input.endStructure_1xqz0n_k$(tmp0_desc);
        return NotificationSendMethods().new_com_lightningkite_lightningserver_notifications_subscriptions_NotificationSendMethods_vhe3ws_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [$serializer().new_com_lightningkite_lightningserver_notifications_events_UserEventType_$serializer_b1r9ke_k$(this.typeSerial0__1), get_nullable($serializer_getInstance()), get_nullable($serializer_getInstance()), get_nullable($serializer_getInstance()), get_nullable($serializer_getInstance())];
      }
      typeParametersSerializers_fr94fx_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [this.typeSerial0__1];
      }
      static new_com_lightningkite_lightningserver_notifications_subscriptions_NotificationSendMethods_$serializer_25jatz_k$(typeSerial0) {
        var $this = this.new_com_lightningkite_lightningserver_notifications_subscriptions_NotificationSendMethods_$serializer_u3zkjf_k$();
        $this.typeSerial0__1 = typeSerial0;
        return $this;
      }
    }
    initMetadataForClass($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_0 = $;
  }
  return $serializerClass_0;
}
var NotificationSendMethodsClass;
function NotificationSendMethods() {
  if (NotificationSendMethodsClass === VOID) {
    class $ {
      constructor(_id, email, push, sms, inApp) {
        Companion_getInstance_1();
        inApp = inApp === VOID ? Companion_getInstance().immediately_trp1j6_k$() : inApp;
        this._id_1 = _id;
        this.email_1 = email;
        this.push_1 = push;
        this.sms_1 = sms;
        this.inApp_1 = inApp;
      }
      get__id_18jb1r_k$() {
        return this._id_1;
      }
      copy_lgbw6q_k$(_id, email, push, sms, inApp) {
        return new (NotificationSendMethods())(_id, email, push, sms, inApp);
      }
      copy$default_hu5pe8_k$(_id, email, push, sms, inApp, $super) {
        _id = _id === VOID ? this._id_1 : _id;
        email = email === VOID ? this.email_1 : email;
        push = push === VOID ? this.push_1 : push;
        sms = sms === VOID ? this.sms_1 : sms;
        inApp = inApp === VOID ? this.inApp_1 : inApp;
        return $super === VOID ? this.copy_lgbw6q_k$(_id, email, push, sms, inApp) : $super.copy_lgbw6q_k$.call(this, _id, email, push, sms, inApp);
      }
      toString() {
        return 'NotificationSendMethods(_id=' + this._id_1.toString() + ', email=' + toString(this.email_1) + ', push=' + toString(this.push_1) + ', sms=' + toString(this.sms_1) + ', inApp=' + toString(this.inApp_1) + ')';
      }
      hashCode() {
        var result = this._id_1.hashCode();
        result = imul(result, 31) + (this.email_1 == null ? 0 : this.email_1.hashCode()) | 0;
        result = imul(result, 31) + (this.push_1 == null ? 0 : this.push_1.hashCode()) | 0;
        result = imul(result, 31) + (this.sms_1 == null ? 0 : this.sms_1.hashCode()) | 0;
        result = imul(result, 31) + (this.inApp_1 == null ? 0 : this.inApp_1.hashCode()) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof NotificationSendMethods()))
          return false;
        if (!this._id_1.equals(other._id_1))
          return false;
        if (!equals(this.email_1, other.email_1))
          return false;
        if (!equals(this.push_1, other.push_1))
          return false;
        if (!equals(this.sms_1, other.sms_1))
          return false;
        if (!equals(this.inApp_1, other.inApp_1))
          return false;
        return true;
      }
      static new_com_lightningkite_lightningserver_notifications_subscriptions_NotificationSendMethods_vhe3ws_k$(seen0, _id, email, push, sms, inApp, serializationConstructorMarker) {
        Companion_getInstance_1();
        if (!(15 === (15 & seen0))) {
          throwMissingFieldException(seen0, 15, Companion_getInstance_1().$cachedDescriptor_1);
        }
        var $this = createThis(this);
        $this._id_1 = _id;
        $this.email_1 = email;
        $this.push_1 = push;
        $this.sms_1 = sms;
        if (0 === (seen0 & 16))
          $this.inApp_1 = Companion_getInstance().immediately_trp1j6_k$();
        else
          $this.inApp_1 = inApp;
        return $this;
      }
    }
    initMetadataForClass($, 'NotificationSendMethods', VOID, VOID, [HasId()], VOID, VOID, {0: Companion_getInstance_1});
    NotificationSendMethodsClass = $;
  }
  return NotificationSendMethodsClass;
}
//region block: exports
export {
  NotificationSendMethods as NotificationSendMethods1rnwccbrbx64q,
  Companion_getInstance_1 as Companion_getInstance1y5mh6uowmcdd,
  Companion_getInstance_0 as Companion_getInstance4qyyemyqnult,
};
//endregion

//# sourceMappingURL=subscriptionModels.mjs.map
